import { render, staticRenderFns } from "./MobileSafetyRegularAssessmentCreate.vue?vue&type=template&id=210d5c9a&scoped=true&"
import script from "./MobileSafetyRegularAssessmentCreate.vue?vue&type=script&lang=js&"
export * from "./MobileSafetyRegularAssessmentCreate.vue?vue&type=script&lang=js&"
import style0 from "./MobileSafetyRegularAssessmentCreate.vue?vue&type=style&index=0&id=210d5c9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210d5c9a",
  null
  
)

export default component.exports